import config from "appConfig";
import { LayoutComponents } from "packages/lesson/dist/@types";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 4,
        rows: 4,
        colSpan: {
          "0:0": 2,
        },
        rowSpan: {
          "0:0": 4,
        },
        colsSize: [1, 1, 0.1, 1],
        rowsSize: [0.5, 0.5, 0.5, 0.5],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/scenario-1.svg`,
                  },
                },
              },
            },
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `Sound insulation target between technical room and classroom: 50 dB`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 700,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-end",
                  justifyContent: "flex-start",
                  paddingBottom: "5%",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-happy.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">SPACE SAVING</span><br />Neither the technical room nor the classroom need to be reduced in space to integrate this access door.`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-happy.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">COST SAVING</span><br />No acoustic door proposed.`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      textAlign: "left",
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-sad.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">ACOUSTIC INSULATION OBTAINED ON SITE</span><br />The sound insulation obtained with a non-acoustic door downgrades the overall acoustic performance of the separating wall. The acoustic target is not achieved and noise distrubance from mechanical equipment may occur in the classroom.`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
